import apiClient from './apiClient';

const authService = {
    login: (username, password) =>
        apiClient.post(`/auth/login`, { username, password }),

    register: (username, password, email, displayName, channelName, marketingConsent, websiteUrlHoney) =>
        apiClient.post(`/auth/register`, {
            username,
            password,
            email,
            display_name: displayName,
            channel_name: channelName,
            marketing_consent: marketingConsent,
            website_url_honey: websiteUrlHoney
        }),

    verifyEmail: (token) => apiClient.post(`/auth/verify`, { token }),

    resendVerification: () => apiClient.post(`/auth/resend-verification`),

    forgotPassword: (email) => apiClient.post(`/auth/forgot-password`, { email }),

    resetPassword: (token, password) => apiClient.post(`/auth/reset-password`, { token, password }),

    verifyResetToken: (token) => apiClient.get(`/auth/reset-password/verify`, { params: { token } }),

    logout: () => apiClient.post(`/auth/logout`),

    getMe: (options = {}) => apiClient.get(`/auth/me`, { ...options }),

    updateProfile: (updates) => apiClient.put(`/auth/profile`, updates),

    getBuildInfo: () => apiClient.get(`/build-info`),

    cancelSubscription: () => apiClient.put(`/auth/subscription/cancel`),

    deleteAccount: () => apiClient.delete(`/auth/account`),
};

export default authService;
